import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import styles from '../../ChestInventory.scss';
import ChestBalance from '../ChestBalance/ChestBalance';
import Grid from '../Grid/Grid';

import { TXTWCL_You_currently_donXt_have_any_C_ELL } from './ChestGrid.messages.json';

interface Props {
  showBalance?: boolean;
}

const ChestGrid: React.FC<Props> = ({ showBalance = true }) => {
  const { data } = useSelector(select.chestInventory.get);
  const chests = data?.chests || [];
  const availableCount = data?.availableCount || 0;

  return data ? (
    <>
      {showBalance && <ChestBalance availableCount={availableCount} />}
      <Grid chests={chests} />
      {isEmpty(chests) && availableCount === 0 && (
        <div className={styles.noChests}>
          <Translation {...TXTWCL_You_currently_donXt_have_any_C_ELL} />
        </div>
      )}
    </>
  ) : (
    <div className={styles.mpcSpinner}>
      <div className={styles.b1} />
      <div className={styles.b2} />
      <div className={styles.b3} />
      <div className={styles.b4} />
      <div className={styles.b5} />
      <div className={styles.b6} />
      <div />
    </div>
  );
};

export default ChestGrid;
